import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input"];

  showDatePickerPanel() {
    this.inputTarget.showPicker();
  }
}
